/*
  Table Ready Cards: the made-to-order ship window, carried past the cart.

  The cart print notice (snippets/cart-print-notice.liquid) renders a hidden [data-trc-delivery-window] marker in
  the cart drawer and on the cart page: whether the cart holds a made-to-order line (custom cards, a Creator Deck,
  a premade reorder), the cart attributes it has now, and the print schedule ([data-trc-print-config]). From the
  print-countdown engine (snippets/print-countdown-core.liquid, window.TRCPrintEngine) this script stores the next
  print run on the cart as attributes:

    _TRC ship from / to         "2026-10-24" / "2026-10-27"  (the ship window the cart shows: "Estimated to ship Oct 24 to 27")
    _TRC print cutoff           "2026-10-18T06:59:00.000Z"
    _TRC print cutoff display   "Sat, Oct 17 at 11:59 PM Pacific Time" (the shopper's own time zone; for staff)
  and, for one release (checkouts and Function versions from before the ship window), the old arrival window:
    _TRC arrival window         "Oct 28 to Nov 2"
    _TRC arrival from / to      "2026-10-28" / "2026-11-02"
    _TRC ship date              "2026-10-26"

  The TRC Shopify app's delivery Function names the ship window in each shipping option at checkout, and the
  order confirmation email repeats it (docs/order-confirmation-delivery-window.md). A cart with no made-to-order
  line has them all cleared.

  When:
  - the cart renders or changes (the marker is drawn again): a background /cart/update.js, only when the values
    differ, with a timeout. A failure is quiet and checkout still works (the Function then says "ships after your
    cards are printed").
  - the Saturday cutoff passes with the cart open: a timer, and a check when the tab is shown again.
  - right before checkout (the cart page and drawer forms, both POST /cart with name="checkout"): the window is
    computed again and sent with that same form as attributes[...] fields. Nothing waits, nothing is fetched, so
    checkout is never held up; any error leaves the form as it was.
  Express buttons (Shop Pay, PayPal) skip the form: they use what the background update stored.
*/
(function () {
  if (window.TRCDeliveryWindow) return;

  var KEYS = {
    shipFrom: '_TRC ship from',
    shipTo: '_TRC ship to',
    window: '_TRC arrival window',
    from: '_TRC arrival from',
    to: '_TRC arrival to',
    ship: '_TRC ship date',
    cutoff: '_TRC print cutoff',
    cutoffText: '_TRC print cutoff display'
  };
  var ORDER = ['shipFrom', 'shipTo', 'window', 'from', 'to', 'ship', 'cutoff', 'cutoffText'];
  var DATA = { shipFrom: 'ship-from', shipTo: 'ship-to', window: 'window', from: 'from', to: 'to', ship: 'ship', cutoff: 'cutoff', cutoffText: 'cutoff-text' };
  var RETRY_MS = 30000;
  var MAX_TIMER_MS = 2147000000;

  var state = { timeoutMs: 8000, confirmed: null, confirmedNode: null, sending: null, failedAt: 0, failedSig: null, timer: null, debounce: null };

  function blank() {
    var out = {};
    for (var i = 0; i < ORDER.length; i++) out[ORDER[i]] = '';
    return out;
  }
  function sig(values) {
    var parts = [];
    for (var i = 0; i < ORDER.length; i++) parts.push(values[ORDER[i]] || '');
    return parts.join('\n');
  }
  function empty(values) {
    for (var i = 0; i < ORDER.length; i++) if (values[ORDER[i]]) return false;
    return true;
  }

  function marker() {
    var all = document.querySelectorAll('[data-trc-delivery-window]');
    return all.length ? all[all.length - 1] : null;
  }

  // The cart's attributes when the marker was drawn.
  function current(node) {
    var out = blank();
    if (!node) return out;
    for (var i = 0; i < ORDER.length; i++) out[ORDER[i]] = node.getAttribute('data-current-' + DATA[ORDER[i]]) || '';
    return out;
  }

  // What the cart should carry now: the next print run for a made-to-order cart, nothing otherwise (or when the
  // engine or the browser's date support fails).
  function desired(node) {
    var out = blank();
    out.cutoffInstant = null;
    if (!node || node.getAttribute('data-made-to-order') !== 'true') return out;
    try {
      var engine = window.TRCPrintEngine;
      var config = node.querySelector('[data-trc-print-config]');
      if (!engine || !config) return out;
      var cfg = engine.config(config);
      // A cart with a Fireball Foil line ships later by the foil production delay, as its product page showed.
      var e = engine.estimate(cfg, node.getAttribute('data-foil') === 'true' ? cfg.foilDelay : 0);
      var next = { shipFrom: e.shipFrom, shipTo: e.shipTo, window: e.window, from: e.from, to: e.to, ship: e.ship, cutoff: e.cutoff, cutoffText: e.cutoffText };
      for (var i = 0; i < ORDER.length; i++) if (typeof next[ORDER[i]] !== 'string' || !next[ORDER[i]]) return out;
      next.cutoffInstant = e.cutoffInstant;
      return next;
    } catch (error) {
      return out;
    }
  }

  function attributes(values) {
    var out = {};
    for (var i = 0; i < ORDER.length; i++) out[KEYS[ORDER[i]]] = values[ORDER[i]] || '';
    return out;
  }

  function updateUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'cart/update.js';
  }

  // POST /cart/update.js with a timeout. Resolves true or false, never rejects. An empty value removes the attribute.
  function send(values) {
    return new Promise(function (resolve) {
      var done = false;
      var controller = null;
      try { controller = typeof AbortController === 'function' ? new AbortController() : null; } catch (error) { controller = null; }
      function finish(ok) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve(ok);
      }
      var timer = setTimeout(function () {
        if (controller) { try { controller.abort(); } catch (error) {} }
        finish(false);
      }, state.timeoutMs);
      if (typeof window.fetch !== 'function') return finish(false);
      var options = {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes(values) })
      };
      if (controller) options.signal = controller.signal;
      var request;
      try { request = window.fetch(updateUrl(), options); } catch (error) { return finish(false); }
      Promise.resolve(request).then(function (response) { finish(Boolean(response && response.ok)); }, function () { finish(false); });
    });
  }

  // The cart's own change queue (assets/cart.js) is busy: wait for it, so the update never races a quantity change.
  function cartBusy() {
    try { return typeof CartItems !== 'undefined' && CartItems && typeof CartItems.idle === 'function' && !CartItems.idle(); } catch (error) { return false; }
  }

  // Recompute when the run closes with the cart still open.
  function scheduleCutoff(values) {
    clearTimeout(state.timer);
    state.timer = null;
    var at = values.cutoffInstant && values.cutoffInstant.getTime ? values.cutoffInstant.getTime() : NaN;
    if (isNaN(at)) return;
    var wait = Math.min(Math.max(at - Date.now() + 1000, 1000), MAX_TIMER_MS);
    state.timer = setTimeout(function () { state.timer = null; sync(); }, wait);
  }

  function sync() {
    var node = marker();
    if (!node) return Promise.resolve('none');
    var want = desired(node);
    scheduleCutoff(want);
    var wantSig = sig(want);
    var have = current(node);
    if (sig(have) === wantSig) { state.confirmed = wantSig; state.confirmedNode = node; return Promise.resolve('same'); }
    if (state.sending === wantSig) return Promise.resolve('same');
    // Stored already, and the cart has not been drawn again since: the marker is just older than the update.
    // A freshly drawn marker without the values is the cart's word: write them again.
    if (state.confirmed === wantSig && state.confirmedNode === node) return Promise.resolve('same');
    if (state.failedSig === wantSig && Date.now() - state.failedAt < RETRY_MS) return Promise.resolve('waiting');
    if (cartBusy()) { later(500); return Promise.resolve('busy'); }
    state.sending = wantSig;
    return send(want).then(function (ok) {
      if (state.sending === wantSig) state.sending = null;
      if (ok) {
        state.confirmed = wantSig;
        state.confirmedNode = node;
        state.failedSig = null;
        return 'sent';
      }
      state.failedSig = wantSig;
      state.failedAt = Date.now();
      return 'failed';
    });
  }

  function later(ms) {
    clearTimeout(state.debounce);
    state.debounce = setTimeout(function () {
      state.debounce = null;
      try { sync(); } catch (error) {}
    }, ms);
  }

  // A submit of a checkout form: the drawer's form, or the cart page's form#cart whose button sits outside it
  // (form="cart"). Safari before 15.4 has no event.submitter: then any submit of a form with a checkout button.
  function checkoutForm(event) {
    var form = event && event.target;
    if (!form || String(form.tagName).toUpperCase() !== 'FORM' || typeof form.querySelector !== 'function') return null;
    var submitter = event.submitter || null;
    var button = submitter
      ? (submitter.name === 'checkout' ? submitter : null)
      : form.querySelector('[name="checkout"]') || (form.id ? document.querySelector('[name="checkout"][form="' + form.id + '"]') : null);
    return button ? form : null;
  }

  function setField(form, key, value) {
    var name = 'attributes[' + key + ']';
    var fields = form.querySelectorAll('input[data-trc-delivery-window-field]');
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].name === name) { fields[i].value = value; return; }
    }
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute('data-trc-delivery-window-field', '');
    form.appendChild(input);
  }

  // Right before checkout: the window computed again (a cart left open past the Saturday cutoff gets the next run)
  // rides along with the form. Clears stale values from a cart that no longer has a made-to-order line.
  function onSubmit(event) {
    try {
      var form = checkoutForm(event);
      if (!form) return;
      var node = marker();
      if (!node) return;
      var want = desired(node);
      if (empty(want) && empty(current(node)) && (state.confirmed === null || state.confirmed === sig(blank()))) return;
      for (var i = 0; i < ORDER.length; i++) setField(form, KEYS[ORDER[i]], want[ORDER[i]] || '');
    } catch (error) {
      // Never hold checkout back.
    }
  }

  function start() {
    later(0);
    if (window.MutationObserver && document.body) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && ((n.hasAttribute && n.hasAttribute('data-trc-delivery-window')) || (n.querySelector && n.querySelector('[data-trc-delivery-window]')))) {
              later(250);
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') later(250); });
    window.addEventListener('pageshow', function (event) { if (event && event.persisted) later(250); });
  }

  document.addEventListener('submit', onSubmit, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.TRCDeliveryWindow = { KEYS: KEYS, sync: sync, desired: desired, current: current, onSubmit: onSubmit, state: state };
})();
